<template>
  <div></div>
</template>
<script>
  import { mapState } from 'vuex';
  export default {
    computed: {
      ...mapState(['pageData']),
    },
    mounted() {
      this.$router.push('/step/' + this.pageData.Steps[0].Slug);
    },
  };
</script>

<style lang="scss" scoped></style>
